import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface BulkShortlistCandidateJobParams {
  jobId: string;
  candidateIds: string[];
}

export const useBulkShortlistCandidateJobMutation = () => {
  return useMutation({
    mutationFn: async ({
      jobId,
      candidateIds,
    }: BulkShortlistCandidateJobParams) => {
      const { data } = await fetchClient.POST(
        candidateEndpoints.shortlistCandidates,
        {
          params: {
            path: { jobId },
          },
          body: { candidateIds },
        },
      );

      return data;
    },
    onSettled: (_data, _error, variables) => {
      const { jobId } = variables;
      const listQueryKey = candidateJobQueryKeys.list(jobId);

      invalidateQuery(listQueryKey)();
    },
  });
};
